import React from 'react';
import { Helmet } from "react-helmet";
import Layout from '../components/Layout';
import AudiForm from '../components/AudiForm';
import Disclaimer from '../components/Disclaimer';
import ReturnToButton from '../components/ReturnToButton';
import MaintenanceMessage from '../components/MaintenanceMessage';
import IconVoiceCall1 from '../audi-ui-components/icons/VoiceCall1';
import IconCarHandover from '../audi-ui-components/icons/CarHandover';
import IconManeuveringAssist from '../audi-ui-components/icons/ManeuveringAssist';
import IconMyDealer from '../audi-ui-components/icons/MyDealer';
import IconTraffic from '../components/IconTraffic';
import { formatMobile } from '../functions/textFormatting';
import { prefCentreService } from '../functions/apiRequestHelper';
import { gtmPageview } from '../functions/gtm';
import queryString from 'query-string';
import _debounce from 'lodash/debounce';
import {
    UI_AUDI_MIN,
    PATH_CONTACTUS,
    PATH_THANKS,
    FIELD_SELECT,
    FIELD_TEXT,
    FIELD_TEXTAREA,
    FIELD_CHECKBOX_GROUP,
    MAINTENANCE_SF
} from '../constants';

class ContactUs extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            windowWidth: 0,
            user: {},
            isFetchingUser: true,
            submitted: false
        }
        this._debouncedResize = _debounce(this.handleResize, 1000);
    }

    componentDidMount() {
        const query = queryString.parse(this.props.location.search);
        if (query.sfid) {
            prefCentreService.get(query.sfid).then((result) => {
                this.setState({user: result, isFetchingUser: false});
            }).catch((error) => {
                console.error('user error', error);
                this.setState({isFetchingUser: false});
            });
        } else {
            this.setState({isFetchingUser: false});
        }
        window.addEventListener("resize", this._debouncedResize);
        this.handleResize();
        gtmPageview(PATH_CONTACTUS);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this._debouncedResize);
    }

    handleResize = () => {
        this.setState({windowWidth: window.innerWidth});
    }

    onSubmit = (values) => {
        window.scrollTo(0,0);
        this.setState({submitted: true});
        // this.props.history.push(`${PATH_CONTACTUS}${PATH_THANKS}${this.props.location.search}`);
        let el = document.querySelector(".contact-us__thanks");
        if (el) {
          el.scrollIntoView({behavior: "smooth", block: "center"});
        }
        gtmPageview(`${PATH_CONTACTUS}${PATH_THANKS}`);
    }

    render() {
        const query = queryString.parse(this.props.location.search);
        const {submitted, user, isFetchingUser} = this.state;
        var prefillMobile = "";
        if (user && user.mobile && user.mobile.indexOf('04') === 0) {
            prefillMobile = user.mobile.replace(/\s/g, '');
        }

        let apiProp = {};
        if (query.myaudi) {
            apiProp = {api: `${process.env.RAZZLE_MYAUDI_API}/2/request/contactus`};
        }

        var device = "Desktop";
        if (this.state.windowWidth <= 768) {
            device = "Tablet";
        }
        if (this.state.windowWidth <= 414) {
            device = "Mobile";
        }

        const fields = [
            [
                {
                    field: FIELD_TEXT,
                    name: "firstName",
                    label: "First name *",
                    value: user.firstName || "",
                    colClass: "col-12 col-tiny"
                },
                {
                    field: FIELD_TEXT,
                    name: "lastName",
                    label: "Last name *",
                    value: user.lastName || "",
                    colClass: "col-12 col-tiny"
                }
            ],
            {
                field: FIELD_TEXT,
                name: "emailAddress",
                label: "Email address *",
                value: user.email || ""
            },
            [
                {
                    field: FIELD_TEXT,
                    name: "mobilePhone",
                    label: "Mobile phone *",
                    value: prefillMobile,
                    formatValue: formatMobile,
                    colClass: "col-12 col-small-6"
                },
                {
                    field: FIELD_TEXT,
                    name: "postCode",
                    label: "Postcode *",
                    value: user.postcode || "",
                    colClass: "col-12 col-small-6"
                }
            ],
            {
                field: FIELD_CHECKBOX_GROUP,
                name: "preferredContactMethod",
                label: "Your preferred contact method *",
                options: [{
                  label: "Email",
                  value: "Email"
                },
                {
                  label: "Call",
                  value: "Phone"
                }],
                delimeter: ";",
                value: user.preferredContactMethod || "Email",
                checkboxClassName: "me-5 mb-3"
            },
            {
              node: <p>Your vehicle details (optional)</p>
            },
            [
              {
                field: FIELD_TEXT,
                name: "rego",
                label: "Vehicle Registration"
              },
              {
                node: <span>Or</span>,
                colClass: "col-12 col-tiny-auto align-self-center"
              },
              {
                field: FIELD_TEXT,
                name: "vin",
                label: "VIN"
              }
            ],
            {
                field: FIELD_SELECT,
                name: "subject",
                label: "Select a topic *",
                options: ["Servicing", "Parts", "Warranty", "Accessories", "Feedback", "General Enquiry", "Dealer Investor Enquiry"]
            },
            {
                field: FIELD_TEXTAREA,
                name: "comment",
                label: "Your message *"
            }
        ];

        return (
            <Layout ui={query.ui || UI_AUDI_MIN} theme={query.theme} embedded={query.embedded}>
                <Helmet>
                    <title>Contact Us | Audi Australia</title>
                </Helmet>

                <main className="audi-forms__page contact-us">
                
                  <div className="text-center pt-3 pt-medium-5">
                    <h1 className="aui-headline-2 mb-4">Contact us</h1>
                    {MAINTENANCE_SF && <MaintenanceMessage opts={[
                      <>Email us at <a className="aui-textlink" href="mailto:customerassistance@audi-info.com.au">customerassistance@audi-info.com.au</a></>,
                      <>Call us on <a className="aui-textlink" href="tel:1300557405">1300 557 405</a></>
                    ]} />}
                    <div className="row justify-content-center mb-5">
                      <div className="col-12 col-medium-6">
                        If there’s something we can help you with, please don't hesitate to contact the Audi Australia team.
                      </div>
                    </div>
                    <div className="row" style={{fontSize: "16px"}}>
                      <div className="col-12 col-small-6 col-medium-6 col-xlarge mb-5">
                        <p className="mb-2"><IconVoiceCall1 small /></p>
                        <p className="aui-font-extended mb-2"><b>Customer Care</b></p>
                        <p className="mb-2" style={{fontSize: "85%"}}>Mon-Fri from 8am to 6pm</p>
                        <p className="aui-font-extended"><a className="aui-textlink" href="tel:1800502834">1800 50 2834</a></p>
                      </div>
                      <div className="col-12 col-small-6 col-medium-6 col-xlarge mb-5">
                        <p className="mb-2"><IconCarHandover small /></p>
                        <p className="aui-font-extended mb-2"><b>Vehicle Owner Information Update</b></p>
                        <p className="aui-font-extended"><a className="aui-textlink" href="https://forms.audi.com.au/change-vehicle-ownership?ui=audi">Complete the form here</a></p>
                      </div>
                      <div className="col-12 col-small-6 col-medium-4 col-xlarge mb-5">
                        <p className="mb-2"><IconManeuveringAssist small /></p>
                        <p className="aui-font-extended mb-2"><b>AudiCare 24h Roadside Assistance</b></p>
                        <p className="aui-font-extended"><a className="aui-textlink" href="tel:1800818833">1800 818 833</a></p>
                      </div>
                      <div className="col-12 col-small-6 col-medium-4 col-xlarge mb-5">
                        <p className="mb-2"><IconMyDealer small /></p>
                        <p className="aui-font-extended mb-2"><b>Sales Enquiries</b></p>
                        <p className="aui-font-extended"><a className="aui-textlink" href="https://forms.audi.com.au/locate-a-dealer?ui=audi">Find a dealer</a></p>
                      </div>
                      <div className="col-12 col-medium-4 col-xlarge mb-5">
                        <p className="mb-2"><IconTraffic small /></p>
                        <p className="aui-font-extended mb-2"><b>Dealer Investor Enquiries</b></p>
                        <p className="mb-2" style={{fontSize: "85%"}}>Contact our dealership development team via the Audi Customer Experience Centre</p>
                      </div>
                    </div>
                    <hr className="mb-5" />
                  </div>
                  
                  <div className="row justify-content-center">
                    <div className="col-12 col-medium-8 col-large-6">

                      {submitted && <div className="mb-5 contact-us__thanks">
                        <p className="mb-3 aui-headline-4">Thank you for your online enquiry</p>
                        <p className="mb-3">Your message has been received and an Audi representative will be in touch as soon as possible.</p>
                        <p className="mb-3">Warm regards,<br /><b>The Audi Team</b></p>
                        <ReturnToButton query={query} theme={query.theme} />
                      </div>}

                      {!submitted && <div>
                        <p className="text-center aui-headline-4 mb-5">Submit an online enquiry</p>
                        {!isFetchingUser && <AudiForm formName="contactUs" theme={query.theme}
                            fields={fields}
                            schema={{
                              vin: {isVin: {message: "Please enter a valid VIN"}},
                              subject: {presence: { message: "Please select an option", allowEmpty: false }},
                              comment: {presence: { message: "Please leave us a message", allowEmpty: false }}
                            }}
                            hiddenFields={{dealerId: query.d, device: device}}
                            preSubmit={(payload) => {
                              let newComment = payload.comment + `\n\n Preferred contact method: ${payload.preferredContactMethod}`;
                              payload.comment = newComment;
                              return payload;
                            }}
                            onSubmitSuccess={this.onSubmit}
                            submitLabel="Contact Us"
                            style={{maxWidth: "840px"}}
                            {...apiProp}
                        />}
                        <p className="mb-3 aui-small">All fields marked with * are mandatory.</p>
                        <Disclaimer />
                      </div>}
                      
                    </div>
                  </div>

                </main>
            </Layout>
        );
    }

}

export default ContactUs;
